import React from 'react';
import './Header.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';

function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const onHomeContact = (e) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
      // wait for navigation then scroll
      setTimeout(() => {
        const el = document.getElementById('contact');
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 50);
    } else {
      const el = document.getElementById('contact');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const handleScrollTo = (id, e) => {
    if (e) e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 120);
    } else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleHome = (e) => {
    if (e) e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 80);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <header className="header">
      <div className="logo">
        <img 
          src="/dabra_logo.png" 
          alt="Dabra Logo" 
          style={{ height: '32px', width: 'auto', filter: 'brightness(0) invert(1)' }}
        />
      </div>
      <nav>
        <a href="/" onClick={handleHome}>Home</a>
        <a href="#services" onClick={(e)=>handleScrollTo('services', e)}>Services</a>
        <a href="#intro" onClick={(e)=>handleScrollTo('intro', e)}>Introduction</a>
        <a href="#contact" onClick={onHomeContact}>Contact</a>
        <Link to="/blog" className="nav-blog">Blog</Link>
      </nav>
    </header>
  );
}

export default Header;
